import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const LancamentoVendasList = (props) => <DefaultDataTable data={props} />
